module.exports = __webpack_public_path__ + "img/07-18.ed6872bf.png";